import create from "zustand"

const useStore = create((set) => ({
  steps: 0,
  exitPath: [],
}))

export default useStore
